exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link-header-logo[data-v-128b26ed]{display:inline-block;max-width:300px;height:50px;line-height:50px;box-sizing:border-box}.link-header-logo .lenovo-link[data-v-128b26ed]{display:inline-block;height:50px;width:auto}.link-header-logo .custom-logo[data-v-128b26ed]{max-width:300px;max-height:50px}.link-header-logo .lenovo-logo[data-v-128b26ed]{width:208px;height:20px;line-height:50px;margin:15px auto}", ""]);

// exports
